import React from 'react';
import { Pencil, Trash2, User } from 'lucide-react';
import { cn } from '@/lib/utils';

const CharacterCard = ({ character, onEdit, onDelete, compact = false }) => {
    const imageUrl = character.data_urls?.[0] || character.image_url || character.data_url;
    const imageCount = character.data_urls?.length || 1;

    return (
        <div className={cn(
            'relative group rounded-lg overflow-hidden border bg-muted/20 cursor-pointer transition-all duration-200 hover:shadow-md',
            compact ? 'aspect-square' : 'aspect-square'
        )}>
            {imageUrl ? (
                <img
                    src={imageUrl}
                    alt={character.name || 'Character reference'}
                    className="w-full h-full object-cover"
                />
            ) : (
                <div className="w-full h-full flex items-center justify-center bg-muted/40">
                    <User className="h-8 w-8 text-muted-foreground/40" />
                </div>
            )}

            {imageCount > 1 && (
                <span className="absolute top-2 left-2 bg-black/60 text-white text-[10px] px-1.5 py-0.5 rounded-full backdrop-blur-sm z-10">
                    {imageCount} photos
                </span>
            )}

            {/* Bottom gradient overlay with name/role */}
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent p-2 pt-6">
                <p className={cn(
                    'text-white font-medium truncate',
                    compact ? 'text-xs' : 'text-sm'
                )}>
                    {character.name || 'Unnamed'}
                </p>
                {character.role && (
                    <span className={cn(
                        'inline-block bg-white/20 text-white rounded px-1.5 py-0.5 mt-0.5 truncate max-w-full backdrop-blur-sm',
                        compact ? 'text-[10px]' : 'text-xs'
                    )}>
                        {character.role}
                    </span>
                )}
            </div>

            {/* Hover actions */}
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors">
                <div className="absolute top-2 right-2 flex gap-1.5 opacity-0 group-hover:opacity-100 transition-opacity">
                    {onEdit && (
                        <button
                            className="p-1.5 rounded-full bg-black/50 text-white hover:bg-black/70 transition-colors backdrop-blur-sm"
                            onClick={(e) => {
                                e.stopPropagation();
                                onEdit(character);
                            }}
                        >
                            <Pencil className="h-3 w-3" />
                        </button>
                    )}
                    {onDelete && (
                        <button
                            className="p-1.5 rounded-full bg-red-500/80 text-white hover:bg-red-600 transition-colors backdrop-blur-sm"
                            onClick={(e) => {
                                e.stopPropagation();
                                onDelete(character.character_id);
                            }}
                        >
                            <Trash2 className="h-3 w-3" />
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CharacterCard;
